// extracted by mini-css-extract-plugin
export default {"container":"dy89ZQ","button":"QQuI8t","separator":"RWrfXo","container--mobile":"yWnCB2"};